'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_SitesView$$anon$39() {
  this.bz7 = null;
  this.bz5 = null;
  this.bz6 = false;
  this.bz3 = null;
  this.bz4 = false;
  this.bz8 = false;
  this.bz9 = false;
  this.bz7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_SitesView$$anon$39 as $c_Lpresto_SitesView$$anon$39 };
$p = $c_Lpresto_SitesView$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SitesView$$anon$39;
/** @constructor */
function $h_Lpresto_SitesView$$anon$39() {
}
export { $h_Lpresto_SitesView$$anon$39 as $h_Lpresto_SitesView$$anon$39 };
$h_Lpresto_SitesView$$anon$39.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bz7;
});
$p.t = (function() {
  if ((!this.bz6)) {
    this.bz5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bz6 = true;
  }
  return this.bz5;
});
$p.ae = (function() {
  if ((!this.bz4)) {
    this.bz3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().v9(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bz4 = true;
  }
  return this.bz3;
});
$p.w = (function() {
  if ((!this.bz9)) {
    this.bz8 = false;
    this.bz9 = true;
  }
  return this.bz8;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_SitesView$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SitesView$$anon$39, "presto.SitesView$$anon$39", ({
  RH: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_SitesView$$anon$39 as $d_Lpresto_SitesView$$anon$39 };
//# sourceMappingURL=presto.-Sites-View$$anon$39.js.map
